import type {ReactNode} from 'react'
import {createContext, useCallback, useContext} from 'react'
import {useCookie} from 'react-use'
import {LEAD_ID_STORAGE_KEY, MOSS_DOMAIN} from 'src/common/constants'

type LeadIdContextType = {
  leadId: string | null
  setLeadId: (id: string) => void
}

const LeadIdContext = createContext<LeadIdContextType | undefined>(undefined)

export const LeadIdProvider = ({children}: {children: ReactNode}) => {
  const [leadIdCookie, updateLeadIdCookie] = useCookie(LEAD_ID_STORAGE_KEY)

  const setLeadId = useCallback(
    (id: string) => {
      updateLeadIdCookie(id, {
        domain: MOSS_DOMAIN,
      })
    },
    [updateLeadIdCookie],
  )

  return <LeadIdContext.Provider value={{leadId: leadIdCookie || null, setLeadId}}>{children}</LeadIdContext.Provider>
}

export const useLeadIdContext = () => {
  const context = useContext(LeadIdContext)

  if (context === undefined) {
    throw new Error('useLeadIdContext must be used within a LeadIdProvider')
  }

  return context
}
